// extracted by mini-css-extract-plugin
module.exports = {"root":"IdealTenant_root__TS7M8","card":"IdealTenant_card__T2FXI","cardRow":"IdealTenant_cardRow__sbXq4","footer":"IdealTenant_footer__odUGX"};